import { RequestTracker } from "@/messenger/models/requestTracker";

export const SET_REQUEST_TRACKER = "SET_REQUEST_TRACKER";

export const setRequestTrackerAC = (request: RequestTracker) => ({
    type: SET_REQUEST_TRACKER,
    data: request,
});